import {
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Typography,
  Stack,
  Button,
  Box
} from "@mui/material";
import moment from "moment";
import React, {  useState } from "react";
import { connect } from "react-redux";
import {
  approveExitRequest,
  rejectRequest,
  cancelEmployeeExitRequest,
} from "../../../store/exit/actions";
import ConfirmationDialog from "../../common/components/ConfirmationDialog";

import { useRequiredAuth } from "../../common/guard/requiredAuth";
import EditExitRequestLetterDialog from "../../employees/components/EditExitRequestLetterDialog";
import PdfViewer from "../../common/components/PdfViewer";
import ViewExitRequestAttachments from "./ViewExitRequestAttachments";

const ApproveExitDialog = (props) => {
  const {
    approveRequestForm,
    setApproveRequestForm,
    rejectRequest,
    employeeExitRequest,
    approveExitRequest,
    cancelEmployeeExitRequest,
  } = props;

  const [showCancelConfirmationDialog, setShowCancelConfirmationDialog] =
    useState(false);
  const [showRejectRequestForm, setShowRejectRequestForm] = useState(false);
  const [showApproveRequestForm, setShowApproveRequestForm] = useState(false);
  const [reason, setReason] = useState("");
  const [pkiPassword, setPkiPassword] = useState("");


  const onClose = () => {
    setShowCancelConfirmationDialog(false);
    setApproveRequestForm(false);
    setShowRejectRequestForm(false);
    setShowApproveRequestForm(false);
  };

  const [showEmployeeExitForm, setShowEmployeeExitForm] = useState(false);

  const { hasPermissions } = useRequiredAuth();

  return (
    <>
      <Dialog
        onClose={onClose}
        aria-labelledby="customized-dialog-title"
        open={approveRequestForm}
        fullWidth
        maxWidth={"md"}
      >
        {showEmployeeExitForm && (
          <EditExitRequestLetterDialog
            showEmployeeExitForm={showEmployeeExitForm}
            setShowEmployeeExitForm={setShowEmployeeExitForm}
          />
        )}
        <DialogTitle>
          <Typography
            variant="overline"
            display="block"
            className="font-weight-bold"
          >
            <span>Exit Request</span> /{" "}
            <span className="text-primary mr-1">
              {employeeExitRequest?.exitType || ""}
            </span>
            - {employeeExitRequest?.employeeNames || ""}
          </Typography>
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <span className="material-icons">close</span>
          </IconButton>

          <div className="mt-4">
           
            {employeeExitRequest && (
              <span
                style={{ fontSize: "12px" }}
                className={`${
                  +employeeExitRequest.statusId === 2
                    ? "badge badge-success w-100"
                    : [3].includes(+employeeExitRequest.statusId)
                    ? "badge badge-danger w-100"
                    : [1].includes(+employeeExitRequest.statusId)
                    ? "badge badge-primary w-100"
                    : [1003].includes(+employeeExitRequest.statusId)
                    ? "badge badge-warning w-100"
                    : "badge badge-secondary w-100"
                }`}
              >
                {employeeExitRequest.statusName}
              </span>
            )}
          </div>
        </DialogTitle>

        <DialogContent>
          {employeeExitRequest && (
            <Box sx={{ width: "100%", minHeight: "95vh" }} className="mt-1">
              {employeeExitRequest &&
                [3, 2, 1002].includes(employeeExitRequest.statusId) && (
                  <>
                    {[3, 1002].includes(employeeExitRequest.statusId) && (
                      <>
                        <div
                          className="card  w-100"
                          style={{
                            backgroundColor: "#fff",
                            borderLeft: "2px solid #3f51b5",
                            borderLeft: "2px solid #3f51b5",
                            borderRadius: "4px",
                          }}
                        >
                          <div className="card-header w-100">
                            Request {employeeExitRequest.statusName}
                          </div>
                          <div className="card-body w-100">
                            <p className="small p-0 ms-2 mb-0 rounded-3">
                              Reason: {employeeExitRequest.reason}
                            </p>
                          </div>
                        </div>
                      </>
                    )}
                    {employeeExitRequest.statusId === 2 && (
                      <>
                        {!!employeeExitRequest?.docReferenceId && (
                          <>
                            <PdfViewer
                              url={
                                process.env.REACT_APP_FILES_URL +
                                "/preview/" +
                                employeeExitRequest?.docReferenceId
                              }
                            />
                          </>
                        )}
                        {!employeeExitRequest?.docReferenceId && employeeExitRequest?.enableToGenerateLetter && (
                          <>
                            <div
                              className="card  w-100"
                              style={{
                                backgroundColor: "#fff",
                                borderLeft: "2px solid #3f51b5",
                                borderLeft: "2px solid #3f51b5",
                                borderRadius: "4px",
                              }}
                            >
                              <div className="card-body w-100">
                                <p className="small p-0 ms-2 mb-0 rounded-3">
                                  No letter was found because the request was
                                  approved when this feature wasn't in the
                                  system.
                                </p>
                              </div>
                            </div>
                          </>
                        )}
                      </>
                    )}
                  </>
                )}
           
            
                  <table>
                    <tbody>
                      <tr>
                        <th scope="row">Employee</th>
                        <td>
                          {employeeExitRequest.lastName +
                            " " +
                            employeeExitRequest.firstName}
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Exit request</th>
                        <td>
                          <strong className="text-primary">
                            {employeeExitRequest.exitType}
                          </strong>
                          {employeeExitRequest.exitTypeId === 0 && (
                            <>
                              <span className="text-capitalize d-block">
                                To
                              </span>
                              <div className="text-capitalize d-block">
                                <div>{employeeExitRequest.toUnitName}</div>
                                <strong className="text-dark">
                                  ({employeeExitRequest.toPositionName})
                                </strong>
                              </div>
                            </>
                          )}
                          {employeeExitRequest.exitTypeId === 6 && (
                            <>
                              <span className="text-capitalize d-block">
                                To
                              </span>
                              <div className="t d-block">
                                <div>{employeeExitRequest.toEntityName}</div> on
                                the post of
                                <strong className="ml-1 text-dark">
                                  {employeeExitRequest.toPositionName}(
                                  {employeeExitRequest.toUnitName})
                                </strong>
                              </div>
                            </>
                          )}
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Reason</th>
                        <td>{employeeExitRequest.reason}</td>
                      </tr>
                      <tr>
                        <th scope="row">Effective on</th>
                        <td>
                          {moment(employeeExitRequest.effectiveDate).format(
                            "LL"
                          )}
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Requested on</th>
                        <td>
                          {moment(employeeExitRequest.createdOn).format("LLL")}
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Request by</th>
                        <td>{employeeExitRequest.requestedBy}</td>
                      </tr>
                      {employeeExitRequest.verifiedBy && (
                        <>
                          <tr>
                            <th scope="row">Verified by</th>
                            <td>{employeeExitRequest.verifiedBy}</td>
                          </tr>
                          <tr>
                            <th scope="row">Verified On</th>
                            <td>
                              {" "}
                              {moment(employeeExitRequest.verifiedOn).format(
                                "LLL"
                              )}
                            </td>
                          </tr>
                        </>
                      )}

                      {employeeExitRequest.statusId === 3 && (
                        <>
                          <tr>
                            <th scope="row">Rejected by</th>
                            <td>{employeeExitRequest.statusByName}</td>
                          </tr>
                          <tr>
                            <th scope="row">Rejected On</th>
                            <td>
                              {" "}
                              {moment(employeeExitRequest.statusOn).format(
                                "LLL"
                              )}
                            </td>
                          </tr>
                        </>
                      )}
                      {employeeExitRequest.statusId === 2 && (
                        <>
                          <tr>
                            <th scope="row">Approved by</th>
                            <td>{employeeExitRequest.statusByName}</td>
                          </tr>
                          <tr>
                            <th scope="row">Approved On</th>
                            <td>
                              {" "}
                              {moment(employeeExitRequest.statusOn).format(
                                "LLL"
                              )}
                            </td>
                          </tr>
                        </>
                      )}

                      <tr>
                        <th scope="row">Status</th>
                        <td>
                          <span
                            className={`badge badge-${
                              employeeExitRequest.statusId === 1
                                ? "info"
                                : employeeExitRequest.statusId === 3
                                ? "danger"
                                : employeeExitRequest.statusId === 2
                                ? "success"
                                : employeeExitRequest.statusId === 1003
                                ? "warning"
                                : "primary"
                            }`}
                          >
                            {employeeExitRequest.statusName}
                          </span>

                        </td>
                      </tr>
                      {!!employeeExitRequest.statusComment && (
                        <tr
                          className={`border ${
                            employeeExitRequest.statusId === 2
                              ? "border-success"
                              : "border-danger"
                          }`}
                        >
                          <th scope="row">Comment</th>
                          <td>{employeeExitRequest.statusComment}</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
               
            
                  <div className="mt-3">
                  <ViewExitRequestAttachments
                    requestId={employeeExitRequest.id}
                    canEdit={
                      !!hasPermissions(["IS_HR"]) &&
                      [1].includes(employeeExitRequest.statusId)
                    }
                  />
                  </div>
              
             
            </Box>
          )}
        </DialogContent>
        {employeeExitRequest && (
          <DialogActions>
            <Stack direction="row" spacing={2} className="mx-auto">
              {[1, 1003].includes(employeeExitRequest.statusId) && (
                <>
                  {!!hasPermissions(["IS_CBM"]) &&
                    [1].includes(employeeExitRequest.statusId) && (
                      <>
                        <Button
                          variant="contained"
                          color="success"
                          startIcon={
                            <span className="material-icons mr-1">
                              done_all
                            </span>
                          }
                          onClick={() => {
                            approveExitRequest(
                              {
                                requestId: employeeExitRequest.id,
                                employeePositionId:
                                  employeeExitRequest.employeePositionId,
                              },
                              onClose
                            );
                          }}
                        >
                          Approve
                        </Button>

                        {/* <Button
                          variant="contained"
                          color="warning"
                          endIcon={
                            <span className="material-icons mr-1">cancel</span>
                          }
                          onClick={() => {
                            setShowRejectRequestForm(true);
                          }}
                        >
                          Reject
                        </Button> */}
                      </>
                    )}

                </>
              )}
            </Stack>
          </DialogActions>
        )}
      </Dialog>
      {showCancelConfirmationDialog && employeeExitRequest && (
        <ConfirmationDialog
          confirmationDialog={showCancelConfirmationDialog}
          message={`Are you sure you want to cancel the exit request for ${
            employeeExitRequest?.lastName + " " + employeeExitRequest?.firstName
          }?`}
          setConfirmationDialog={setShowCancelConfirmationDialog}
          onYes={() => {
            cancelEmployeeExitRequest(employeeExitRequest, onClose);
          }}
        />
      )}
      {showRejectRequestForm && employeeExitRequest && (
        <ConfirmationDialog
          disabled={!reason}
          confirmationDialog={showRejectRequestForm}
          message={
            <>
              <p>
                Are you sure you want to{" "}
                <strong className="text-danger">reject</strong> this request?
              </p>
              <TextField
                fullWidth
                size="small"
                multiline
                rows={4}
                name="Reason"
                label="Type your reason .."
                variant="outlined"
                placeholder="Type your reason  .."
                value={reason}
                onChange={(e) => {
                  setReason(e.target.value || "");
                }}
              />
            </>
          }
          setConfirmationDialog={setShowRejectRequestForm}
          onYes={() => {
            rejectRequest(
              {
                exitRequestId: employeeExitRequest.id,
                statusComment: reason,
              },
              onClose
            );
          }}
        />
      )}
      {showApproveRequestForm && employeeExitRequest && (
        <ConfirmationDialog
          disabled={!pkiPassword}
          confirmationDialog={showApproveRequestForm}
          message={
            <>
              <p>Enter your RISA Digital signature password to sign</p>

              <form>
                <TextField
                  fullWidth
                  size="small"
                  id="pki-password"
                  rows={4}
                  name="pki-password"
                  type="password"
                  label="Enter your RISA Digital signature password to sign"
                  variant="outlined"
                  placeholder="Enter your RISA Digital signature password to sign"
                  value={pkiPassword}
                  onChange={(e) => {
                    setPkiPassword(e.target.value || "");
                  }}
                />
              </form>
            </>
          }
          setConfirmationDialog={setShowApproveRequestForm}
          onYes={() => {
            approveExitRequest(
              {
                requestId: employeeExitRequest.id,
                password: pkiPassword,
                employeePositionId: employeeExitRequest.employeePositionId,
              },
              onClose
            );
          }}
        />
      )}
    </>
  );
};

const mapStateToProps = ({
  loading,
  employeeExitRequest,
  env,
  exitRequestAttachments,
}) => {
  return {
    loading,
    employeeExitRequest,
    env,
    exitRequestAttachments,
  };
};
export default connect(mapStateToProps, {
  approveExitRequest,
  rejectRequest,
  cancelEmployeeExitRequest
})(ApproveExitDialog);
